import { MapViewProps } from "@avenue-8/sidekick-ui";
import { PropertyDto } from "@cma/shared/apis/comps/cma/generated";
import { buildListingMlsKey } from "@cma/shared/helpers/listing-mls-key";
import { getListingCurrentPrice } from "@cma/shared/helpers/listing-price-resolver";

export const convertPropertyDtoToMapViewProperty = (params: {
  propertyDto: PropertyDto;
  isSubjectProperty: boolean;
}): MapViewProps["properties"][number] => {
  const { propertyDto, isSubjectProperty } = params;
  const mlsKey = buildListingMlsKey({
    mlsId: propertyDto.mlsId || "",
    mlsSource: propertyDto.mlsSource || "",
  });
  return {
    id: mlsKey,
    isSubjectProperty,
    lat: propertyDto.latitude || 0,
    lng: propertyDto.longitude || 0,
    propertyData: {
      id: mlsKey,
      addressLine1: propertyDto.addressLine1 || "",
      addressLine2: propertyDto.addressLine2 || null,
      city: propertyDto.city || "",
      state: propertyDto.state || "",
      zipCode: propertyDto.zipCode || "",
      coverPhoto: propertyDto.images?.[0]?.url || null,
      propertyStatus: propertyDto.listingStatus || "",
      propertyType: propertyDto.propertyType || "",
      internalSize: propertyDto.livingSpace || null,
      currentPrice: getListingCurrentPrice({
        status: propertyDto.listingStatus,
        soldPrice: propertyDto.soldPrice,
        listPrice: propertyDto.listPrice,
      }),
      beds: propertyDto.beds || null,
      baths: propertyDto.baths || null,
    },
  };
};
